import { createRoot } from "react-dom/client";
import StandaloneChatbot from "./iframe/standaloneChatbot";
import "./index.css";
import type { Brand, Environment } from "./lib/ChatbotConfig";

const container = document.getElementById("root")!;
const root = createRoot(container);

// This build is served into the chat iframe, one deployment for all brands, so
// the brand normally comes from the embedding page (see useParentBrand).
// REACT_APP_BRAND is only the fallback for a host that cannot identify itself;
// deliberately not defaulted here, so the config guard reports it instead of
// quietly serving one brand's theme and data protection statement to everyone.
root.render(
  <StandaloneChatbot
    brand={process.env.REACT_APP_BRAND as Brand}
    environment={process.env.REACT_APP_ENVIRONMENT as Environment}
  />,
);
